import { stripTypename } from "@apollo/client/utilities"

import { serializer } from "./serializer"

export function createSerializer(apiType: string) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (data: any, headers: Headers) => {
    if (data) {
      headers.set("Content-Type", "application/json")
      return {
        body: JSON.stringify(
          serializer.serialize(apiType, stripTypename(data))
        ),
        headers
      }
    }
    return { headers, body: undefined }
  }
}
